var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.translation)?_c('div',{staticClass:"translation"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openTranslation}},[_vm._v(_vm._s(_vm.$t('translation')))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.translation)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }